import { useIntl } from 'react-intl'
import NotFoundComponent from '../../../../../components/stories/molecules/not-found'
import {
  EmptyPlanTreeContainer,
  EmptyContent,
  EmptyPlanTreeButtonsContainer
} from '../../../styled-component'
import { Plan } from '../../../../../components/stories/atoms/icons/entities'
import colorsOptions from '../../../../../components/stories/fundamentals/colors-styles/constants'
import ButtonComponent from '../../../../../components/stories/atoms/button'
import { buttonVariantOptions } from '../../../../../components/stories/atoms/button/constants'
import PropTypes from 'prop-types'
import { textStyleSizeOptions } from '../../../../../components/stories/fundamentals/text-styles/constants'
import { planPermissionOptions } from '../../../constants'

const PlanMenuTileEmptyPlanTree = ({
  handleBackFolder = () => {},
  handleCreatePlan = () => {},
  isFolder = false,
  userPermissions
}) => {
  const { formatMessage } = useIntl()

  const canCreatePlans = userPermissions?.includes(
    planPermissionOptions.CREATE_PLAN
  )

  const title = isFolder
    ? 'plans_folderEmpty'
    : 'plans_overview_empty-state_title'

  const description = canCreatePlans
    ? 'plans_overview_empty-state_description'
    : 'plans_overview_empty-state_description_restricted'

  return (
    <EmptyPlanTreeContainer>
      <EmptyContent>
        <NotFoundComponent
          icon={
            <Plan
              style={{ width: '144px', height: '144px' }}
              stroke={colorsOptions.greys['grey-50']}
            />
          }
          header={formatMessage({ id: title })}
          headerSize={textStyleSizeOptions['TEXT-XXL']}
          description={formatMessage({
            id: description
          })}
          descriptionSize={textStyleSizeOptions['TEXT-L']}
        />
        <EmptyPlanTreeButtonsContainer>
          {isFolder && (
            <ButtonComponent
              variant={buttonVariantOptions['TERTIARY-WHITE-FILL']}
              onClick={handleBackFolder}
            >
              {formatMessage({ id: 'back' })}
            </ButtonComponent>
          )}

          {canCreatePlans && (
            <ButtonComponent
              variant={buttonVariantOptions.PRIMARY}
              onClick={handleCreatePlan}
            >
              {formatMessage({ id: 'plans_action_import' })}
            </ButtonComponent>
          )}
        </EmptyPlanTreeButtonsContainer>
      </EmptyContent>
    </EmptyPlanTreeContainer>
  )
}

PlanMenuTileEmptyPlanTree.propTypes = {
  handleBackFolder: PropTypes.func,
  handleCreatePlan: PropTypes.func,
  isFolder: PropTypes.bool,
  userPermissions: PropTypes.array
}

export default PlanMenuTileEmptyPlanTree
